import { Injectable, inject } from '@angular/core';
import { BrandingService } from '@next/core-lib/branding';

@Injectable({
  providedIn: 'root',
})
export class EmployeeTenantGuard {
  private readonly brandingService = inject(BrandingService);

  canActivate(): boolean {
    return this.brandingService.isTenant('Agravis');
  }
}
